import { Component, signal, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Subscription } from 'rxjs';
import { RecaptchaService } from 'app/services/recaptcha.service';
import { validateForm } from 'app/shared/form-elements/form-validateForm.function';
import { PfsRegisterVm } from 'app/shared/generated/Models/Public/PfsRegisterVm';
import { pcgSettings } from 'app/shared/generated/pcg-settings';
import { SystemMessage } from 'app/core/system-message/system-message-service';

import { NotificationService } from 'app/notification.service';

@Component({
    selector: 'pcg-pfs-register',
    templateUrl: './pfs-register.component.html',
    styleUrls: ['./pfs-register.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PfsRegisterComponent {
    
    honeypotControl;
    
    subscriptions: Subscription = new Subscription();
    formGroup = PfsRegisterVm.Form;
    model = PfsRegisterVm.GetModel(this.formGroup);
    
    emailMatch = true;    
    isSuccess = false;

    pfsUrl : string = "";

    isSubmitting = signal<boolean>(false);

    constructor(
        private recaptchaService : RecaptchaService
        , private ns : NotificationService
    ) { }

    ngOnInit() { 
        this.setEnv(); 
        this.setUpHoneyPot();
    }

    setUpHoneyPot() {
		this.formGroup.controls['honeyPot'].setValidators(this.requireFalse());
		this.formGroup.updateValueAndValidity();
	}

    requireFalse() : ValidatorFn {
		return (control : AbstractControl) : ValidationErrors | null => {
			if (control.value === true) { return { honeyPot: true}; }
			return null;
		}
	}

    setEnv() {
        if (pcgSettings.mode === 'Development') { this.pfsUrl = "https://localhost:44384/"; } 
        else if (pcgSettings.mode === 'Demo') { this.pfsUrl = "https://demo.fdohcentralpharmacy.com/"; 	} 
        else { this.pfsUrl = "https://fdohcentralpharmacy.com/"; }
	}

    sanitize(email: string, isConfirm: boolean) {
        var strTempString = email.trim();
        strTempString = strTempString.replace("'", "");
        strTempString = strTempString.replace("--", "");
        strTempString = strTempString.replace("/", "");
        strTempString = strTempString.replace("&", "");
        strTempString = strTempString.replace("?", "");
        strTempString = strTempString.replace(":", "");
        strTempString = strTempString.replace(",", "");
        strTempString = strTempString.replace(";", "");
        strTempString = strTempString.replace("NULL", "");
        strTempString = strTempString.replace("xp_", "");
        strTempString.replace(/[\n\r]+/g, '');
        strTempString.replace('\\', '');

        if (isConfirm === true) { this.formGroup.controls['confirmEmail'].setValue(strTempString); } 
        else { this.formGroup.controls['email'].setValue(strTempString); }
    }

    onSubmit() {
        // Validate emails
        if (this.formGroup.controls['confirmEmail'].value !== this.formGroup.controls['email'].value) {
            this.emailMatch = false;
            return;
        }
        this.emailMatch = true;

        // Validate form
        if (!this.formGroup.valid) {            
            validateForm(this.formGroup); 
            this.isSuccess = false;
            return;
        }

        // Submit with reCAPTCHA protection
        this.recaptchaService.submit(
            {
                action: 'registerPfsUser',
                apiEndpoint: 'api/PublicPfsRegister/RegisterPfsUser',
                formGroup: this.formGroup,
                loadingSignal: this.isSubmitting
            },
            {
                onSuccess: (msg: SystemMessage) => {
                    if (msg.isSuccessful) {
                        this.isSuccess = true;
                        this.formGroup.reset();
                    } else {
                        this.isSuccess = false;
                        this.ns.showError(msg.message);
                    }
                },
                onCreateTokenError: () => {
                    this.isSuccess = false;
                },
                onVerifyTokenError: () => {
                    this.isSuccess = false;
                }
            }
        );
    }
}
